import { request } from "@/common/api";
import { Buttons } from "@/components/atoms/Buttons";
import { useQuery } from "@tanstack/react-query";
import { AlertText } from "@/components/atoms/AlertText";
import { useNavigate } from "react-router";
import { CommentList } from "@/components/molecules/CommentList";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { useRecoilValue } from "recoil";
import { loginTypeState } from "@/common/states/user";
import { GET_CHEER_MESSAGES } from "@/common/querykeys";
import { StudentCheerMessage } from "@/common/types/cheerMessage";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";
import { Loading } from "@/components/atoms/Loading";

export const CommentHistoryPage = () => {
  const navigate = useNavigate();
  const loginType = useRecoilValue(loginTypeState);

  const { data: cheerMessages, isPending } = useQuery<StudentCheerMessage[]>({
    queryKey: [GET_CHEER_MESSAGES],
    queryFn: async () => {
      let url = "/cheer-message/student";
      if (loginType === "guardian") {
        url = "/cheer-message/guardian";
      }

      return await request<StudentCheerMessage[]>({
        method: "GET",
        url: url,
      });
    },
  });

  if (isPending) {
    return <Loading />;
  }

  return (
    <>
      {cheerMessages && cheerMessages.length > 0 ? (
        <MainTemplate
          nav={false}
          subPage={true}
          menuBtn={false}
          pageTitle="응원 메시지 내역"
          buttonLeft={
            <Buttons
              type="button"
              size="headerTextIcon"
              layout="text"
              color="bright100"
              icon={<IconArrow />}
              label="설정"
              onClick={() => navigate(-1)}
            />
          }
        >
          <CommentList data={cheerMessages} />
        </MainTemplate>
      ) : (
        <>
          {loginType === "student" ? (
            <MainTemplate
              nav={false}
              subPage={true}
              menuBtn={false}
              pageTitle="응원 메시지 내역"
              buttonLeft={
                <Buttons
                  type="button"
                  size="headerTextIcon"
                  layout="text"
                  color="bright100"
                  icon={<IconArrow />}
                  label="설정"
                  onClick={() => navigate(-1)}
                />
              }
            >
              <AlertText
                mainText="아직 응원 메시지가 도착하지 않았어요."
                subText={
                  <>
                    아직 법정보호자를 연결하지 않았다면,
                    <br />
                    '설정' &gt; '법정보호자 연결 설정'에서 연결할 수 있습니다.
                  </>
                }
              />
            </MainTemplate>
          ) : (
            <MainTemplate
              nav={false}
              subPage={true}
              menuBtn={false}
              pageTitle="응원 메시지 내역"
              buttonLeft={
                <Buttons
                  type="button"
                  size="headerTextIcon"
                  layout="text"
                  color="bright100"
                  icon={<IconArrow />}
                  label="설정"
                  onClick={() => navigate(-1)}
                />
              }
            >
              <AlertText
                mainText="응원의 한 마디가 자녀에게 큰 힘이 될 수 있습니다."
                subText={
                  <>
                    따뜻한 응원과 격려를 전달해 주세요.
                    <br />
                    간단한 응원의 메시지가 큰 힘이 됩니다.
                  </>
                }
              />
            </MainTemplate>
          )}
        </>
      )}
    </>
  );
};
